export const rewards = {
  appBarTitle: "Rewards",
  addReward: "Add New Reward",
  table: {
    points: "Required Points",
    level: "Level",
    reward: "Reward Type",
    status: "Status",
    expiryDate: "Expiry Date",
    totalNumber: "Total Number of Drivers",
    totalEarned: "Drivers Earned",
    totalRedeemed: "Redeemed",
    voucher: "Voucher",
    discount: "Discount",
    chargingCard: "Recharging Card",
    active: "Active",
    inactive: "Inactive",
    expired: "Expired",
    rewardAmount: "Reward Amount",
    rewardCreationDate: "Creation Date",
    rewardDeletionDate: "Deletion Date",
    numberQualifiedEarned: "Qualified Drivers Earned",
    numberUserSelected: "Selected",
    numberExpiredRewards: "Expired",
  },
  filters: {
    reward: "Reward Type",
    status: "Status",
    points: "Required Points",
    level: "Level",
    voucher: "Voucher",
    discount: "Discount",
    chargingCard: "Recharging Card",
    active: "Active",
    inactive: "Inactive",
    expired: "Expired",
  },
  rewardsForm: {
    addTitle: "Add Reward",
    editTitle: "Edit Reward",
    rewardPhoto: "Reward Photo",
    requiredPoints: "Required Points",
    rewardType: "Reward Type",
    voucher: "Voucher",
    discount: "Discount",
    chargingCard: "Recharging Card",
    voucherAmount: "Voucher Amount",
    chargingCardAmount: "Recharging Card Amount",
    discountPercentage: "Discount Value",
    rewardValue: "Reward Value",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    validations: {
      statusRequired: "Status is required",
      pointsRequired: "Required points is required",
      pointsOnlyNumbers: "Required points accepts integer value only",
      pointsMoreThanZero: "Required points must be greater than 0",
      rewardTypeRequired: "Reward type is required",
      voucherAmountRequired: "Voucher Amount is required",
      voucherAmountOnlyNumbers: "Voucher Amount accepts integer value only",
      voucherAmountMoreThanZero: "Voucher Amount must be greater than 0",
      chargingCardAmountRequired: "Recharging Card Amount is required",
      chargingCardAmountOnlyNumbers:
        "Recharging Card Amount accepts integer value only",
      chargingCardAmountMoreThanZero:
        "Recharging Card Amount must be greater than 0",
      discountPercentageRequired: "Discount Value is required",
      discountPercentageOnlyNumbers:
        "Discount Value accepts integer value only",
      discountPercentageMoreThanZero:
        "Discount Value must be between 0 and 100",
    },
    offersLocale: {
      maxValue: "Max Value: ",
      from: "From: ",
      to: "To: ",
      percent: "%",
      egp: "EGP",
    },
  },
  rewardDetails: {
    title: "Reward Details",
    requiredPoints: "Required Points",
    rewardType: "Reward Type",
    level: "Level",
    voucher: "Voucher",
    discount: "Discount",
    chargingCard: "Recharging Card",
    voucherAmount: "Voucher Amount",
    chargingCardAmount: "Recharging Card Amount",
    discountPercentage: "Discount Value",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    expired: "Expired",
    expiryDate: "Expiry Date",
    editStatusTitle: "Edit Reward Status",
    editStatusDescription: "Are you sure you want to change reward status to ",
    deleteRewardTitle: "Delete Reward",
    deleteRewardDescription: "Are you sure you want to delete the reward ?",
    deleteRewardPhotoTitle: "Delete Reward Photo",
    deleteRewardPhotoDescription:
      "Are you sure you want to delete the reward photo ?",
    exportRewardingReport: "Export Rewarding Report",
    exportRewardingReportMsg:
      "Are you sure you want to export all rewarding details?",
    reportExcelHeaders: {
      number: "No.",
      milestone: "Milestone (Required Points)",
      milestoneType: "Milestone Type",
      rewardType: "Reward Type",
      amount: "Amount",
      status: "Status",
      totalDriversEarned: "Total Drivers Earned",
      totalDriversQualified: "Total Drivers Qualified",
      totalDriversRedeemed: "Total Drivers Redeemed",
      totalAmount: "Total Amount",
    },
  },
  messages: {
    rewardAdded: "Reward was added successfully",
    rewardEdited: "Reward was edited successfully",
    rewardDeleted: "Reward was deleted successfully",
  },
};
